import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { Permission, PermissionService } from '../services/user/permission.service';

type DeniedUrl = string | unknown[];

export const permissionGuard: CanActivateFn = (route) => {
  const requiredPermission = route.data['requiredPermission'] as Permission | undefined;

  if (requiredPermission === undefined) {
    return true;
  }

  const deniedUrl = (route.data['deniedUrl'] as DeniedUrl | undefined) ?? ['/no-permission'];
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  return permissionService
    .hasPermission(requiredPermission)
    .pipe(
      map((hasPermission) =>
        hasPermission
          ? true
          : router.createUrlTree(Array.isArray(deniedUrl) ? deniedUrl : [deniedUrl]),
      ),
    );
};
